import findResult, { removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../../constants';
import { findAllDatasetMetrics } from './state';

const destroyDataset = withDraft((draft, { items }) => {
  findAllDatasetMetrics(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.datasetMetrics, category, code);
      if (item) {
        draft.datasetMetrics[category].results = (
          removeItemByCode(draft.datasetMetrics[category].results, item)
        );
      }
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
};
